import React, { useContext, useEffect, useRef, useState } from "react";
import "./All_Products.css";
import OurProduct from "../HomePage/OurProduct/OurProduct";
import Filter_btn from "../Common-Component/common_btn/filter_btn/Filter_btn";
import Filter_offcanvas from "./filter_offcanvas/Filter_offcanvas";
import { faFilter } from "@fortawesome/free-solid-svg-icons";
import { Col, Container, Row } from "react-bootstrap";
import DoubleHeading from "../Common-Component/DoubleHeading/DoubleHeading";
import { Context } from "../../utils/context";
import { AllProductsData, Products } from "../../utils/apis/Product/Product";
import Product_Card from "../Common-Component/Product_Card/Product_Card";
import Lottie from "react-lottie";
import Loader_lottie from "../Animation/Loader_lottie/Loader_lottie";
import { Link, useLocation } from "react-router-dom";
import { ShimmerThumbnail } from "react-shimmer-effects";

function All_Products() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const {
    IMG_URL,
    setShimmerLoader,
    shimmerLoader,
    setSearchTerm,
    searchTerm,
  } = useContext(Context);
  const [products, setProducts] = useState([]);
  const [showFilter, setShowFilter] = useState(false);
  const [showSort, setShowSort] = useState(false);
  const [numToShow, setNumToShow] = useState();
  const [showAll, setShowAll] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 575);
  const sectionRef = useRef(null);

  const [sortOrder, setSortOrder] = useState("");

  const [sizeSearach, setSizeSearch] = useState([]);

  const [category, setCategory] = useState([]);
  const [reset, setReset] = useState();
  const handlePriceHighToLow = async (value) => {
    await setSortOrder(value);
  };
  const location = useLocation();
  // const [searchTerm, setSearchTerm] = useState(null);

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);

    const term = queryParams.get("search");
    setSearchTerm(term !== null ? term.trim() : "");
  }, [location.search]);

  const getProduct = async (searchTerm = "") => {
    await setShimmerLoader(true);
    const res = await AllProductsData(
      category,
      sortOrder,
      searchTerm,
      sizeSearach,
    );
    if (res?.success) {
      await setProducts(res?.data?.data);

      await setShimmerLoader(false);
    }
  };

  // useEffect(() => {
  //   if (searchTerm === null) return;
  //   getProduct(searchTerm);

  // }, [searchTerm, reset]);

  useEffect(() => {
    const timer = setTimeout(() => {
      getProduct(searchTerm);
    }, 500);

    return () => clearTimeout(timer);
  }, [category, sortOrder, searchTerm, sizeSearach, reset]);

  const handleShow = () => {
    setShowFilter(true);
    setShowSort(false);
  };

  const handleClose = () => {
    setShowFilter(false);
    setShowSort(false);
  };

  return (
    <>
      <section className="All-Products">
        {/* <div className="filter_holder">
          <div className="filter_btn_holder">
            <Filter_btn btnText="Filter" icon={faFilter} onClick={handleShow} />
          </div>
        </div> */}

        <Container fluid>
          <div className="mb-4 mt-3">
            <DoubleHeading heading={"All Products"} />
          </div>

          {/* Desktop view */}
          <div
            className="desktop_view_product_category_slider mb-5"
            ref={sectionRef}>
            {shimmerLoader ? (
              <ShimmerThumbnail className="shimmerheight" rounded />
            ) : products.length > 0 ? (
              <Row>
                {products.slice(0, numToShow).map((product, index) => {
                  const price =
                    product?.product_multiple_mains?.[0]
                      ?.product_multiple_variants?.[0]?.mrp ||
                    product?.product_variants?.[0]?.mrp;

                  const cutprice =
                    product?.product_multiple_mains?.[0]
                      ?.product_multiple_variants?.[0]?.cutting_price ||
                    product?.product_variants?.[0]?.cutting_price;

                  return (
                    <Col
                      key={index}
                      xxl={3}
                      xl={3}
                      lg={3}
                      md={4}
                      sm={4}
                      xs={6}
                      className="custom_class_product mb-3">
                      <Product_Card
                        image={IMG_URL + product?.image1}
                        text={product?.name}
                        product_id={product?.id}
                        subText={product?.short_description}
                        price={price}
                        cutprice={cutprice}
                        newest={product?.newest}
                        variant_id={product?.product_variants?.[0]?.id}
                        m_variant_id={
                          product?.product_multiple_mains?.[0]
                            ?.product_multiple_variants?.[0]?.id
                        }
                      />
                    </Col>
                  );
                })}
              </Row>
            ) : (
              products.length == 0 && (
                <div className="text-center my-5">
                  <p style={{ fontSize: "48px", marginBottom: "10px" }}>🛍️</p>
                  <h5 style={{ color: "#444", fontWeight: "600" }}>
                    No Products Found
                  </h5>
                 
                </div>
              )

              // <ShimmerThumbnail rounded />
            )}
          </div>

          {/* Mobile view */}
          {/* <div className="mobile_view_product_category_slider" ref={sectionRef}>
            <Row>
              {products && products.length > 0 ? (
                products.slice(0, numToShow).map((product, index) => {
                  const price =
                    product?.product_multiple_mains?.[0]
                      ?.product_multiple_variants?.[0]?.mrp ||
                    product?.product_variants?.[0]?.mrp;

                  const cutprice =
                    product?.product_multiple_mains?.[0]
                      ?.product_multiple_variants?.[0]?.cutting_price ||
                    product?.product_variants?.[0]?.cutting_price;

                  return (
                    <Col
                      key={index}
                      xxl={3}
                      xl={3}
                      lg={3}
                      md={4}
                      sm={4}
                      xs={6}
                      className="custom_class_product"
                    >
                      <Product_Card
                        image={IMG_URL + product?.image1}
                        text={product?.name}
                        product_id={product?.id}
                        subText={product?.short_description}
                        price={price}
                        cutprice={cutprice}
                        newest={product?.newest}
                        variant_id={product?.product_variants?.[0]?.id}
                        m_variant_id={
                          product?.product_multiple_mains?.[0]
                            ?.product_multiple_variants?.[0]?.id
                        }
                      />
                    </Col>
                  );
                })
              ) : (
                <Col xs={12} className="text-center my-4">
                  <h5></h5>
                </Col>
              )}
            </Row>
          </div> */}

          {/* View All/ View Less Button */}
          {/* {products.length > 0 &&
            ((isMobile && numToShow > 0) ||
              (!isMobile && (numToShow < products.length || showAll))) && (
              <div className="view-all mb-5" onClick={toggleShowAll}>
                <p>
                  {isMobile
                    ? numToShow >= products.length
                      ? "View Less"
                      : "View More"
                    : showAll
                    ? "View Less"
                    : "View All"}
                </p>
              </div>
            )} */}
        </Container>
      </section>

      {/* Pass props to control offcanvas */}
      <Filter_offcanvas
        reset={reset}
        setReset={setReset}
        getProduct={getProduct}
        sortOrder={sortOrder}
        show={showFilter}
        handlePriceHighToLow={handlePriceHighToLow}
        setCategory={setCategory}
        category={category}
        handleClose={handleClose}
        sizeSearach={sizeSearach}
        setSizeSearch={setSizeSearch}
      />
      {/* <Sort_offcanvas show={showSort} handleClose={handleCloseSort} /> */}
    </>
  );
}

export default All_Products;
